import React from "react"

import { IInputText } from "./model"

import "./style.scss"

/**
 * Text based input designed to take either text or a password.
 */
export function InputText({
    id,
    type,
    required,
    error,
    focusMessage,
    pattern,
    onFocus,
    placeholder,
    label,
    disabled,
    tooltip,
    value,
    defaultValue,
    callback,
    onChange,
    style,
    className,
    maxLength,
    track,
    autoCapitalize,
}: IInputText) {
    return (
        <div
            style={style}
            className={`ipt mkt
        ${className || ""} 
        ${error ? "error" : ""} 
        ${disabled ? "disabled" : ""}
        ${focusMessage ? "focused" : ""}
      `}
        >
            {label && (
                <label className="ipt-label" htmlFor={id}>
                    <span className="ipt-label-text">{label}</span>
                    {focusMessage && <span className="ipt-focus-text">{focusMessage}</span>}
                    {required && <strong>*</strong>}
                    {tooltip && <span>{tooltip}</span>}
                </label>
            )}
            <div className="ipt-wrapper">
                <input
                    type={type}
                    itemID={id}
                    name={id}
                    id={id}
                    disabled={disabled}
                    placeholder={placeholder}
                    pattern={pattern}
                    value={value}
                    defaultValue={defaultValue}
                    onFocus={onFocus}
                    className={`ipt-input ${track ? "" : "no-track"}`}
                    maxLength={maxLength}
                    autoCapitalize={autoCapitalize}
                    onChange={(event) => {
                        if (onChange) {
                            onChange(event)
                        } else if (callback) {
                            callback(event.target.value, id)
                        }
                    }}
                />
                {error && <span className="ipt-error-message">{error}</span>}
            </div>
        </div>
    )
}

InputText.defaultProps = {
    placeholder: undefined,
    type: "text",
    track: true,
}
